





















import { defineComponent } from '@nuxtjs/composition-api'
import Fieldset from '~/components/car/classifieds/form/fieldsets/handlers/Fieldset.vue'
import BaseFieldsetMixin from '~/components/car/classifieds/form/fieldsets/handlers/BaseFieldsetMixin.vue'
import { defineComponentTranslations } from '~/utils/i18n'
import { useI18n } from '~/compositions/i18n'
import CImg from '~/components/shared/configurable/image/CImg.vue'

export default defineComponent({
  components: { CImg, Fieldset },
  mixins: [BaseFieldsetMixin],
  setup() {
    const { t } = useI18n()
    return { t }
  },
  i18n: defineComponentTranslations({
    online_financing_fieldset: {
      en: 'Online financing through',
      el: 'Online χρηματοδότηση μέσω'
    }
  })
})
